export const AUTH_RETURN_URL_PARAM = "returnUrl";
export const DEFAULT_POST_LOGIN_PATH = "/dashboard";

const BLOCKED_RETURN_PREFIXES = [
  "/authentication/login",
  "/authentication/logout",
  "/authentication/register",
];

/**
 * Allow only same-app relative paths (no protocol, no // open redirects).
 */
export function sanitizeReturnPath(
  path: string | null | undefined
): string | null {
  if (!path || typeof path !== "string") return null;

  const trimmed = path.trim();
  if (!trimmed.startsWith("/")) return null;
  if (trimmed.startsWith("//")) return null;
  if (trimmed.includes("://")) return null;

  const [pathname] = trimmed.split("?");
  if (
    BLOCKED_RETURN_PREFIXES.some(
      (blocked) => pathname === blocked || pathname.startsWith(`${blocked}/`)
    )
  ) {
    return null;
  }

  return trimmed;
}

export function locationToPath(
  location: { pathname?: string; search?: string } | null | undefined
): string | null {
  if (!location?.pathname) return null;
  return `${location.pathname}${location.search ?? ""}`;
}

export function buildLoginPath(returnPath?: string | null): string {
  const safe = sanitizeReturnPath(returnPath);
  if (!safe) return "/authentication/login";
  return `/authentication/login?${AUTH_RETURN_URL_PARAM}=${encodeURIComponent(safe)}`;
}

export function resolvePostLoginPath(options: {
  searchParams?: URLSearchParams | null;
  from?: { pathname?: string; search?: string } | null;
  defaultPath?: string;
}): string {
  const fromQuery = sanitizeReturnPath(
    options.searchParams?.get(AUTH_RETURN_URL_PARAM) ?? null
  );
  if (fromQuery) return fromQuery;

  const fromState = sanitizeReturnPath(locationToPath(options.from));
  if (fromState) return fromState;

  return options.defaultPath ?? DEFAULT_POST_LOGIN_PATH;
}
